import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

const TutorialVideo = ({
  isOpen,
  onClose,
  youtubeLink,
  title,
}: {
  isOpen: boolean;
  onClose: () => void;
  youtubeLink: string;
  title: string;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[720px] sm:max-w-2xl">
        <DialogHeader className="border-b-0">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="px-3xl pb-3xl">
          <iframe
            src={`${youtubeLink}&autoplay=1`}
            title="YouTube video player"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            className="w-full aspect-video rounded-lg"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { TutorialVideo };
